import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const seasonClubs = payload[0]?.value || 0;
    const extraClubs = payload[1]?.value || 0;
    const totalClubs = seasonClubs + extraClubs;

    return (
      <div style={{
        backgroundColor: 'white',
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '4px'
      }}>
        <p style={{ margin: 0, fontWeight: 'bold' }}>{label}</p>
        <p style={{ margin: '5px 0', color: '#90b361' }}>
          Klubber (sesong): {seasonClubs}
        </p>
        {extraClubs > 0 && (
          <p style={{ margin: '5px 0', color: '#6b8a47' }}>
            Ekstra klubber: {extraClubs}
          </p>
        )}
        <p style={{ margin: '5px 0 0 0', fontWeight: 'bold', borderTop: '1px solid #ccc', paddingTop: '5px' }}>
          Totalt (hele året): {totalClubs}
        </p>
      </div>
    );
  }
  return null;
};

export const ClubChart = ({ data }) => {
  // Create a map to store yearly aggregate data
  const yearlyAggregates = new Map();
  data.forEach(item => {
    if (item.part === 'Hele året') {
      yearlyAggregates.set(item.year, {
        clubCount: item.clubCount
      });
    }
  });

  // Transform data and add yearly aggregate values to Vår and Høst entries
  const chartData = data
    .filter(item => item.part !== 'Hele året') // Remove "Hele året" entries from X-axis
    .map(item => {
      const yearlyData = yearlyAggregates.get(item.year);
      // Calculate the additional clubs in the yearly total beyond this season
      const additionalClubs = yearlyData ? Math.max(0, yearlyData.clubCount - item.clubCount) : 0;

      return {
        name: item.part ? `${item.year} ${item.part}` : `${item.year}`,
        year: item.year,
        klubber: item.clubCount,
        klubberTillegg: yearlyData ? additionalClubs : 0,
        hasCompleteData: item.hasCompleteData,
        isYearlyAggregate: false
      };
    });

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart
        data={chartData}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="name"
          angle={-45}
          textAnchor="end"
          height={100}
          style={{ fontSize: '12px' }}
        />
        <YAxis />
        <Tooltip content={<CustomTooltip />} />
        <Legend />
        <Bar
          dataKey="klubber"
          fill="#90b361"
          name="Klubber (sesong)"
          stackId="a"
        />
        <Bar
          dataKey="klubberTillegg"
          fill="#6b8a47"
          name="Ekstra klubber (hele året)"
          stackId="a"
        />
      </BarChart>
    </ResponsiveContainer>
  );
};
